import type { InferType } from 'yup'
import { object, string } from 'yup'

export const PV1PatientCardEditFormSchema = object().shape({
  patientName: string().required().label('Patient Name'),
  dob: string().required().label('Date of birth'),
  gender: string().required().label('Sex'),
  species: string().optional().label('Species'),
  weight: string().optional().label('Weight'),
  guardian: string().optional().label('Guardian'),
  address1: string().required().label('Address 1'),
  address2: string().optional().label('Address 2'),
  city: string().required().label('City'),
  state: string().required().label('State'),
  zip: string().required().label('Zip'),
  phone: string().required().label('Phone'),
})

export type PV1PatientCardEditFormSchemaType = InferType<typeof PV1PatientCardEditFormSchema>
